import {selectDesignerAbility} from '@packages/systems/designer-abilities';
import {useDesignerSelector} from '@packages/systems/designer/flux';
import {useFeatureFlag} from '@packages/systems/feature-config/client';
import {FEATURE_FLAGS} from '@packages/systems/feature-config/shared';

const canEditCodeComponentsSelector = selectDesignerAbility(
  'canEditCodeComponents'
);

export function useCanStartFromCode(): boolean {
  const isEnabled = useFeatureFlag(FEATURE_FLAGS.AICC_START_FROM_CODE);
  const canEditCodeComponents = useDesignerSelector(
    canEditCodeComponentsSelector
  );
  return isEnabled && canEditCodeComponents;
}
